/* HoM Haute — motion layer */
(() => {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const init = () => {
    const main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;

    const targets = [];
    const sections = main.querySelectorAll(':scope > .shopify-section');

    sections.forEach((section, index) => {
      if (index === 0) return; // hero animates on load via CSS

      const cards = section.querySelectorAll('.product-card');
      if (cards.length > 1) {
        // Reveal the section heading, then stagger the cards in.
        section.querySelectorAll('h2, h3').forEach((h) => {
          if (!h.closest('.product-card')) {
            h.classList.add('ux-reveal');
            targets.push(h);
          }
        });
        cards.forEach((card, i) => {
          card.classList.add('ux-reveal');
          card.style.setProperty('--ux-delay', `${Math.min(i * 90, 540)}ms`);
          targets.push(card);
        });
      } else {
        section.classList.add('ux-reveal');
        targets.push(section);
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ux-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );

    targets.forEach((el) => io.observe(el));

    // Safety nets: never leave content hidden.
    const showVisible = () => {
      targets.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('ux-in');
      });
    };
    setTimeout(showVisible, 1200);
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) targets.forEach((el) => el.classList.add('ux-in'));
    });

    // Hero: content fades up and away, media drifts (clamped parallax).
    const hero = main.querySelector(':scope > .shopify-section .hero');
    if (hero) {
      const content = hero.querySelector('.hero__container');
      const media = hero.querySelectorAll('.hero__media');
      let ticking = false;

      const update = () => {
        ticking = false;
        const h = hero.offsetHeight || 1;
        const y = Math.max(window.scrollY, 0);
        const p = Math.min(y / (h * 0.85), 1);
        if (content) {
          content.style.opacity = String(1 - p * 0.95);
          content.style.transform = `translateY(${p * 36}px)`;
        }
        const drift = Math.min(y * 0.12, h * 0.04);
        media.forEach((m) => {
          m.style.transform = `translateY(${drift}px)`;
        });
      };

      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        },
        { passive: true }
      );
      update();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
